import { configureStore } from "../redux/store";
import { Provider } from "react-redux";
import { type PropsWithChildren, Suspense } from "react";
import { SwrProvider } from "./SwrProvider";
import { ToastProvider } from "_components/ToastProvider";
import { UserDeskHubProvider } from "_components/UserDeskHubProvider";
import { Route, useGo } from "_utils/url";
import { useNavigate } from "react-router-dom";

export const Providers = (Props: PropsWithChildren) => {
    Route.go = useGo();
    Route.navigate = useNavigate();

    const { children } = Props;

    return (
        <Provider store={configureStore({})}>
            <ToastProvider />
            <SwrProvider>
                <Suspense>
                    <UserDeskHubProvider />
                </Suspense>
                {children}
            </SwrProvider>
        </Provider>
    );
}
